export const REQUEST_FOR_EXPERT_OPINION_LOADING = 'REQUEST_FOR_EXPERT_OPINION_LOADING';
export const REQUEST_FOR_EXPERT_OPINION_ERROR = 'REQUEST_FOR_EXPERT_OPINION_ERROR';
export const INITIATE_REQUEST_FOR_EXPERT_OPINION_APPLICATION_SUCCESS =
  'INITIATE_REQUEST_FOR_EXPERT_OPINION_APPLICATION_SUCCESS';
export const CLEAR_REQUEST_FOR_EXPERT_OPINION_APPLICATION_ERROR = 'CLEAR_REQUEST_FOR_EXPERT_OPINION_APPLICATION_ERROR';
export const FETCH_APPLICATION_REQUEST_FOR_EXPERT_OPINION_SUCCESS =
  'FETCH_APPLICATION_REQUEST_FOR_EXPERT_OPINION_SUCCESS';
export const FETCH_PROPERTY_REQUEST_FOR_EXPERT_OPINION_SUCCESS = 'FETCH_PROPERTY_REQUEST_FOR_EXPERT_OPINION_SUCCESS';
export const FETCH_DOCUMENTS_REQUEST_FOR_EXPERT_OPINION_SUCCESS = 'FETCH_DOCUMENTS_REQUEST_FOR_EXPERT_OPINION_SUCCESS';
export const SAVE_APPLICATION_REQUEST_FOR_EXPERT_OPINION_SUCCESS =
  'SAVE_APPLICATION_REQUEST_FOR_EXPERT_OPINION_SUCCESS';
export const CHANGE_REQUEST_FOR_EXPERT_OPINION_STEP = 'CHANGE_REQUEST_FOR_EXPERT_OPINION_STEP';
export const REQUEST_FOR_EXPERT_OPINION_CLEAR_DATA = 'REQUEST_FOR_EXPERT_OPINION_CLEAR_DATA';
export const DOWNLOAD_DOCUMENT_REQUEST_FOR_EXPERT_OPINION_SUCCESS =
  'DOWNLOAD_DOCUMENT_REQUEST_FOR_EXPERT_OPINION_SUCCESS';
export const CHECKOUT_REQUEST_FOR_EXPERT_OPINION_APPLICATION = 'CHECKOUT_REQUEST_FOR_EXPERT_OPINION_APPLICATION';
export const CHECKOUT_REQUEST_FOR_EXPERT_OPINION_APPLICATION_SUCCESS =
  'CHECKOUT_REQUEST_FOR_EXPERT_OPINION_APPLICATION_SUCCESS';
export const REQUEST_FOR_EXPERT_OPINION_CANCEL_APPLICATION_SUCCESS =
  'REQUEST_FOR_EXPERT_OPINION_CANCEL_APPLICATION_SUCCESS';
export const APPROVAL_REQUEST_FOR_EXPERT_OPINION_SUCCESS = 'APPROVAL_REQUEST_FOR_EXPERT_OPINION_SUCCESS';
export const POST_RETURN_REQUEST_FOR_EXPERT_OPINION_SUCCESS = 'POST_RETURN_REQUEST_FOR_EXPERT_OPINION_SUCCESS';
export const UPLOAD_REQUEST_FOR_EXPERT_OPINION_DOCUMENT_SUCCESS = 'UPLOAD_REQUEST_FOR_EXPERT_OPINION_DOCUMENT_SUCCESS';
export const DOWNLOAD_REQUEST_FOR_EXPERT_OPINION_CONTRACT_DOCUMENT_SUCCESS =
  'DOWNLOAD_REQUEST_FOR_EXPERT_OPINION_CONTRACT_DOCUMENT_SUCCESS';
export const GET_MULTIPLE_PROPERTIES = 'GET_MULTIPLE_PROPERTIES';

// expert
export const UPDATE_EXPERT_REPORTS_FIELDS = 'UPDATE_EXPERT_REPORTS_FIELDS';
export const ADD_EXPERT_REPORT = 'ADD_EXPERT_REPORT';
export const UPDATE_EXPERT_REPORT = 'UPDATE_EXPERT_REPORT';
export const DELETE_EXPERT_REPORT = 'DELETE_EXPERT_REPORT';
export const EXPERT_OPINION_PAYMENT_BREAKDOWN_SUCCESS = 'EXPERT_OPINION_PAYMENT_BREAKDOWN_SUCCESS';
export const ADD_TO_ERROR = 'ADD_TO_ERROR';
